import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import {EMPTY, Observable} from "rxjs";
import {
    CategoryItem,
    Country,
    DEFAULT_PAGE_SIZE, DuplicateCandidate,
    LeagueCompetitor, LeagueCompetitorFilter,
    PagedFilter,
    Pages
} from "@model";
import {inject} from "@angular/core";
import {LANDING_ROUTE, ORGANISER_DASHBOARD} from "../../app-routing.module";
import {LeagueCompetitorsService} from "@services";
import {extractIdFromSlug} from "@utility";

export const LeagueCompetitorsResolver: ResolveFn<Observable<LeagueCompetitor[]> | any> =
    (route: ActivatedRouteSnapshot,
     _: RouterStateSnapshot,
     router: Router = inject(Router),
     leagueCompetitorsService: LeagueCompetitorsService = inject(LeagueCompetitorsService)): Observable<LeagueCompetitor[]> | any => {
        const isAdmin : boolean = route.data['isAdmin'] ?? false;
        const leagueId = +route.queryParams['leagueId'];
        if (!leagueId) {
            router.navigate(isAdmin ? [ORGANISER_DASHBOARD] : [LANDING_ROUTE]);
            return EMPTY;
        }
        const filter: LeagueCompetitorFilter = new LeagueCompetitorFilter();
        return leagueCompetitorsService.getLeagueCompetitors(leagueId, new PagedFilter(new Pages(DEFAULT_PAGE_SIZE, 1), filter), isAdmin);

}

export const LeagueDuplicateCompetitorsCandidateResolver: ResolveFn<Observable<DuplicateCandidate[]> | any> =
    (route: ActivatedRouteSnapshot,
     _: RouterStateSnapshot,
     router: Router = inject(Router),
     leagueCompetitorsService: LeagueCompetitorsService = inject(LeagueCompetitorsService)): Observable<DuplicateCandidate[]> | any => {
        const leagueId = +route.queryParams['leagueId'];
        if (!leagueId) {
            router.navigate([ORGANISER_DASHBOARD]);
            return EMPTY;
        }
        return leagueCompetitorsService.getLeagueDuplicateCompetitorsCandidates(leagueId);
}

export const LeagueCompetitorsCountriesResolver: ResolveFn<Observable<Country[]> | any> =
    (route: ActivatedRouteSnapshot,
     _: RouterStateSnapshot,
     router: Router = inject(Router),
     leagueCompetitorsService: LeagueCompetitorsService = inject(LeagueCompetitorsService)): Observable<Country[]> | any => {
        const leagueId = route.queryParams['leagueId']
            ? +route.queryParams['leagueId']
            : extractIdFromSlug(route.parent?.params['slug'] ?? '') ?? 0;
        if (!leagueId) {
            router.navigate([LANDING_ROUTE]);
            return EMPTY;
        }
        return leagueCompetitorsService.getLeagueCompetitorsCountries(leagueId);
}

export const LeagueCompetitorsCategoryItemsResolver: ResolveFn<Observable<CategoryItem[]> | any> =
    (route: ActivatedRouteSnapshot,
     _: RouterStateSnapshot,
     router: Router = inject(Router),
     leagueCompetitorsService: LeagueCompetitorsService = inject(LeagueCompetitorsService)): Observable<CategoryItem[]> | any => {
        const leagueId = route.queryParams['leagueId']
            ? +route.queryParams['leagueId']
            : extractIdFromSlug(route.parent?.params['slug'] ?? '') ?? 0;
        const isAdmin : boolean = route.data['isAdmin'] ?? false;
        if (!leagueId) {
            router.navigate([isAdmin ? ORGANISER_DASHBOARD : LANDING_ROUTE]);
            return EMPTY;
        }
        return leagueCompetitorsService.getLeagueCompetitorsCategoryItems(leagueId);
}